export default "__VITE_ASSET__rCitvhg6__"